import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import {
    FETCH_EVENTS, USER_SET_ETH_ADDRESS, USER_FETCH_BETS_ERROR, getBountyUserBets, USER_UPDATE, USER_FETCH_BETS, USER_UPDATE_BALANCES, FETCH_EVENTS_ERROR, getActiveEvents, getEventBets, EVENTS_SET_ACTIVE, EVENTS_POST_BET, USER_FETCH_BETS_SUCCESS, USER_POST_BET, postBountyUserBet, USER_POST_BET_SUCCESS, USER_POST_BET_ERROR, postEventBet, USER_FETCH_BETS_LOADING, USER_AUTH_LOGIN, MODAL_USER_PROMPT_LOGIN, MODAL_SHOW, MODAL_EVENT_BET_POSTED, FETCH_EVENT_DETAILS_BETS, FETCH_EVENT, USER_AUTH_LOGOUT, USER_FETCH_STATS, USER_FETCH_STATS_SUCCESS, getUserStats, SNACKBAR_SHOW, SNACKBAR_NO_ETH_ADDRESS, USER_FETCH_STATS_ERROR, USER_SET_ETH_ADDRESS_ERROR, USER_SET_ETH_ADDRESS_SUCCESS
} from '../constants/action-types';

function* userUpdateBalances({ update }) {



}

function* userUpdate({ user }) {


}

function* userPostBet( data ) {

    if (!firebase.auth().currentUser || firebase.auth().currentUser.isAnonymous)

        return yield put({ type: MODAL_SHOW, closable: true, modal: MODAL_USER_PROMPT_LOGIN })

    try {

        // TODO: would be consistent to use teamId here 
        const payload = yield call((() => firebase.functions().httpsCallable(postEventBet)({
            eventId: data.payload.eventId,
            userPick: data.payload.teamNum,
            uid: firebase.auth().currentUser.uid 
        })))

        // TODO: response is null ? should be the bet.
        
        yield put({type: USER_POST_BET_SUCCESS, eventId: data.payload.eventId })

    }
    catch (e) {

        yield put({ type: USER_POST_BET_ERROR, payload: e.message })

    }

}

function* userPostBetSuccess({ eventId }) {

    yield put({ type: MODAL_SHOW, modal: MODAL_EVENT_BET_POSTED })
    // It's also nice to re-pull the new bets now so the data is updated *live*.
    yield put({type: FETCH_EVENT, eventId })

}

function* userFetchBets() {

    if (!firebase.auth().currentUser)

        return yield put({type: MODAL_SHOW, modal: MODAL_USER_PROMPT_LOGIN})

    yield put ({type: USER_FETCH_BETS_LOADING})

    try {

        const payload = yield call((() => firebase.functions().httpsCallable(getBountyUserBets)({uid: firebase.auth().currentUser.uid})))
        yield put({type: USER_FETCH_BETS_SUCCESS, payload: payload.data })

    }
    catch (e) {
        console.log(e)
        yield put({ type: USER_FETCH_BETS_ERROR, payload: e.message })

    }

}

function* userFetchStats() {

    if (!firebase.auth().currentUser)

        return yield put({type: MODAL_SHOW, modal: MODAL_USER_PROMPT_LOGIN})


    try {
       

        const payload = yield call((() => firebase.functions().httpsCallable(getUserStats)({uid: firebase.auth().currentUser.uid})))
        yield put({type: USER_FETCH_STATS_SUCCESS, payload: payload.data })

        if (!payload.data.eth_address)

            yield put({type: SNACKBAR_SHOW, snackbar: SNACKBAR_NO_ETH_ADDRESS })

    }
    catch (e) {

        yield put({ type: USER_FETCH_STATS_ERROR, payload: e.message })

    }

}

function* userSetEthAddress(data) {
  
    if (!firebase.auth().currentUser)

        return yield put({type: MODAL_SHOW, modal: MODAL_USER_PROMPT_LOGIN})

    try {

        const payload = yield call((() => firebase.functions().httpsCallable('setEthAddress')({uid: firebase.auth().currentUser.uid, ethAddress: data.payload})))
        yield put({type: USER_SET_ETH_ADDRESS_SUCCESS })

    }
    catch (e) {

        yield put({ type: USER_SET_ETH_ADDRESS_ERROR, payload: e.message })

    }

}

function* userLogout() {

    firebase.auth().signOut().then(() => {
        
        window.location = '/'

    }, err => console.log(err));

}

export default [
    takeLatest(USER_UPDATE, userUpdate),
    takeLatest(USER_POST_BET, userPostBet),
    takeLatest(USER_AUTH_LOGOUT, userLogout),
    takeLatest(USER_FETCH_BETS, userFetchBets),
    takeLatest(USER_FETCH_STATS, userFetchStats),
    takeLatest(USER_SET_ETH_ADDRESS, userSetEthAddress),
    takeLatest(USER_UPDATE_BALANCES, userUpdateBalances),
    takeLatest(USER_POST_BET_SUCCESS, userPostBetSuccess),
]


// WEBPACK FOOTER //
// ./src/sagas/user.js